import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { ParsedItemIndexReferenceWrapper } from '../parse-models';
import { parserConfiguration } from '../parser-configuration';
import { parserHelper } from '../parser.helper';
export var BrowserParser =
/*#__PURE__*/
function () {
  function BrowserParser() {
    _classCallCheck(this, BrowserParser);
  }

  _createClass(BrowserParser, [{
    key: "parse",
    value: function parse(html, mainRichTextElement, resolvers, linkedItems) {
      return this.parseInternal(mainRichTextElement, resolvers, html, linkedItems, new ParsedItemIndexReferenceWrapper(0), null);
    }
  }, {
    key: "parseInternal",
    value: function parseInternal(mainRichTextElement, resolvers, html, linkedItems, linkedItemIndex, parentElement) {
      var rootElement = this.createWrapperElement(html); // get all linked items

      var result = this.processRichTextElement(mainRichTextElement, resolvers, rootElement.children, {
        links: [],
        linkedItems: [],
        images: []
      }, linkedItems, linkedItemIndex, parentElement);
      return {
        componentCodenames: result.linkedItems.filter(function (m) {
          return m.itemType === 'component';
        }).map(function (m) {
          return m.dataCodename;
        }),
        linkedItemCodenames: result.linkedItems.filter(function (m) {
          return m.itemType === 'linkedItem';
        }).map(function (m) {
          return m.dataCodename;
        }),
        result: rootElement.innerHTML
      };
    }
  }, {
    key: "processRichTextElement",
    value: function processRichTextElement(mainRichTextElement, resolvers, htmlCollection, result, linkedItems, linkedItemIndex, parentElement) {
      if (!htmlCollection || htmlCollection.length === 0) {// there are no more nodes
      } else {
        // extract objects
        for (var i = 0; i < htmlCollection.length; i++) {
          var element = htmlCollection[i];
          resolvers.elementResolver(parserHelper.convertToParserElement(element));
          var typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined; // process linked items (modular items)

          if (element.attributes && typeAttribute && typeAttribute.value && typeAttribute.value.toLowerCase() === parserConfiguration.modularContentElementData.type.toLowerCase()) {
            var dataCodenameAttribute = element.attributes.getNamedItem(parserConfiguration.modularContentElementData.dataCodename);
            var dataTypeAttribute = element.attributes.getNamedItem(parserConfiguration.modularContentElementData.dataType);

            if (!dataTypeAttribute) {
              throw Error('Missing data type attribute. This is likely an error caused by invalid response.');
            }

            var relAttribute = element.attributes.getNamedItem(parserConfiguration.modularContentElementData.relAttribute);
            var itemType = 'linkedItem';

            if (relAttribute && relAttribute.value === parserConfiguration.modularContentElementData.componentRel) {
              itemType = 'component';
            } // prepare link item object


            var linkItemContentObject = {
              dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
              dataType: dataTypeAttribute ? dataTypeAttribute.value : '',
              itemType: itemType
            };
            var elementParent = element.parentElement;

            if (!elementParent) {
              console.warn("Could not replace linked item '".concat(linkItemContentObject.dataCodename, "' of '").concat(linkItemContentObject.dataType, "' because parent node is undefined. Please report this error if you are seeing this."));
            } else {
              if (dataTypeAttribute.value === 'item') {
                // add to result
                result.linkedItems.push(linkItemContentObject); // resolve linked item

                resolvers.contentItemResolver(parserHelper.convertToParserElement(element), linkItemContentObject.dataCodename, linkedItemIndex.index, parserHelper.getLinkedItem(linkedItems, linkItemContentObject.dataCodename)); // increment index

                linkedItemIndex.increment();
              } else {
                console.warn("Rich text element contains object with unsupported data type '".concat(dataTypeAttribute.value, "'"));
              }
            }
          } // process links
          else if (element.nodeName.toLowerCase() === parserConfiguration.linkElementData.nodeName.toLowerCase()) {
              var dataItemIdAttribute = element.attributes.getNamedItem(parserConfiguration.linkElementData.dataItemId);

              if (dataItemIdAttribute) {
                var linkObject = {
                  dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                }; // add to result

                result.links.push(linkObject); // get original link text (the one inside <a> tag)

                var linkText = element.innerHTML;
                resolvers.urlResolver(parserHelper.convertToParserElement(element), linkObject.dataItemId, linkText, parserHelper.tryGetLink(mainRichTextElement, linkedItems, linkObject.dataItemId));
              }
            } // process images
            else if (element.nodeName.toLowerCase() === parserConfiguration.imageElementData.nodeName.toLowerCase()) {
                var dataImageIdAttribute = element.attributes.getNamedItem(parserConfiguration.imageElementData.dataImageId); // continue only if data image id is present. There could be regular img tags included

                if (dataImageIdAttribute) {
                  var imageObj = {
                    imageId: dataImageIdAttribute.value
                  };
                  result.images.push(imageObj); // resolve image

                  resolvers.imageResolver(parserHelper.convertToParserElement(element), imageObj.imageId, parserHelper.tryGetImage(mainRichTextElement, linkedItems, imageObj.imageId));
                }
              } else {
                // process generic elements
                resolvers.genericElementResolver(parserHelper.convertToParserElement(element));
              } // recursively process child nodes


          if (element.children && element.children.length > 0) {
            this.processRichTextElement(mainRichTextElement, resolvers, element.children, result, linkedItems, linkedItemIndex, parentElement);
          }
        }
      }

      return result;
    }
  }, {
    key: "createWrapperElement",
    value: function createWrapperElement(html) {
      var element = document.createElement(parserConfiguration.linkedItemWrapperElem);
      element.innerHTML = html;
      return element;
    }
  }]);

  return BrowserParser;
}();
export var browserParser = new BrowserParser();